// Mock data para Meu Trampo (Portfólio)

// Paletas de cores pré-definidas
export const colorPalettes = [
  {
    id: 'laranja-pro',
    name: 'Laranja Profissional',
    primary: '#f97316',    // orange-500
    secondary: '#ea580c',  // orange-600
    accent: '#fed7aa',     // orange-200
    gradient: 'from-orange-500 to-amber-500'
  },
  {
    id: 'azul-moderno',
    name: 'Azul Moderno',
    primary: '#3b82f6',    // blue-500
    secondary: '#2563eb',  // blue-600
    accent: '#bfdbfe',     // blue-200
    gradient: 'from-blue-500 to-cyan-500'
  },
  {
    id: 'verde-natura',
    name: 'Verde Natureza',
    primary: '#22c55e',    // green-500
    secondary: '#16a34a',  // green-600
    accent: '#bbf7d0',     // green-200
    gradient: 'from-green-500 to-emerald-500'
  },
  {
    id: 'roxo-elegante',
    name: 'Roxo Elegante',
    primary: '#8b5cf6',    // violet-500
    secondary: '#7c3aed',  // violet-600
    accent: '#ddd6fe',     // violet-200
    gradient: 'from-violet-500 to-purple-600'
  },
  {
    id: 'rosa-moderno',
    name: 'Rosa Moderno',
    primary: '#ec4899',    // pink-500
    secondary: '#db2777',  // pink-600
    accent: '#fbcfe8',     // pink-200
    gradient: 'from-pink-500 to-rose-500'
  },
  {
    id: 'cinza-minimalista',
    name: 'Cinza Minimalista',
    primary: '#64748b',    // slate-500
    secondary: '#475569',  // slate-600
    accent: '#cbd5e1',     // slate-300
    gradient: 'from-slate-600 to-slate-700'
  },
  {
    id: 'dourado-luxo',
    name: 'Dourado Luxo',
    primary: '#d97706',    // amber-600
    secondary: '#b45309',  // amber-700
    accent: '#fde68a',     // amber-200
    gradient: 'from-amber-500 to-yellow-600'
  },
  {
    id: 'turquesa-fresh',
    name: 'Turquesa Fresh',
    primary: '#14b8a6',    // teal-500
    secondary: '#0d9488',  // teal-600
    accent: '#99f6e4',     // teal-200
    gradient: 'from-teal-500 to-cyan-500'
  }
];

// Imagens de capa por nicho
export const coverImages = {
  construcao: [
    'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1200&h=400&fit=crop', // Ferramentas
    'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=1200&h=400&fit=crop', // Obra
    'https://images.pexels.com/photos/5691639/pexels-photo-5691639.jpeg?w=1200&h=400&fit=crop' // Reforma
  ],
  beleza: [
    'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1200&h=400&fit=crop', // Salão
    'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=1200&h=400&fit=crop', // Maquiagem
    'https://images.pexels.com/photos/7755557/pexels-photo-7755557.jpeg?w=1200&h=400&fit=crop' // Hair
  ],
  tecnologia: [
    'https://images.unsplash.com/photo-1613068687893-5e85b4638b56?w=1200&h=400&fit=crop', // Code
    'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=1200&h=400&fit=crop', // Laptop
    'https://images.pexels.com/photos/577585/pexels-photo-577585.jpeg?w=1200&h=400&fit=crop' // Monitor
  ],
  saude: [
    'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1200&h=400&fit=crop', // Gym
    'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1200&h=400&fit=crop', // Workout
    'https://images.pexels.com/photos/6975559/pexels-photo-6975559.jpeg?w=1200&h=400&fit=crop' // Fitness
  ],
  educacao: [
    'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=1200&h=400&fit=crop', // Classroom
    'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=1200&h=400&fit=crop', // Study
    'https://images.pexels.com/photos/6503101/pexels-photo-6503101.jpeg?w=1200&h=400&fit=crop' // Teaching
  ],
  personalizado: [
    'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=1200&h=400&fit=crop', // Abstract gradient
    'https://images.unsplash.com/photo-1557682224-5b8590cd9ec5?w=1200&h=400&fit=crop', // Abstract colors
    'https://images.unsplash.com/photo-1557683316-973673baf926?w=1200&h=400&fit=crop' // Minimal
  ]
};

export const portfolioTemplates = [
  {
    id: 'construcao',
    name: 'Construção & Reformas',
    icon: 'Hammer',
    description: 'Pedreiros, pintores, eletricistas, encanadores',
    categories: ['Reforma completa', 'Pintura', 'Elétrica', 'Hidráulica', 'Acabamento'],
    color: 'orange',
    defaultPalette: 'laranja-pro',
    coverImages: coverImages.construcao
  },
  {
    id: 'beleza',
    name: 'Beleza & Estética',
    icon: 'Sparkles',
    description: 'Cabeleireiros, manicures, maquiadores, designers de sobrancelha',
    categories: ['Cortes', 'Coloração', 'Unhas', 'Maquiagem', 'Sobrancelhas'],
    color: 'pink',
    defaultPalette: 'rosa-moderno',
    coverImages: coverImages.beleza
  },
  {
    id: 'tecnologia',
    name: 'Tecnologia & Digital',
    icon: 'Code',
    description: 'Desenvolvedores, designers, social media, fotógrafos',
    categories: ['Sites', 'Apps', 'Design', 'Redes Sociais', 'Fotografia'],
    color: 'blue',
    defaultPalette: 'azul-moderno',
    coverImages: coverImages.tecnologia
  },
  {
    id: 'saude',
    name: 'Saúde & Bem-estar',
    icon: 'Heart',
    description: 'Personal trainers, nutricionistas, fisioterapeutas, massagistas',
    categories: ['Treinos', 'Nutrição', 'Fisioterapia', 'Massagem', 'Yoga'],
    color: 'green',
    defaultPalette: 'verde-natura',
    coverImages: coverImages.saude
  },
  {
    id: 'educacao',
    name: 'Educação & Mentoria',
    icon: 'GraduationCap',
    description: 'Professores particulares, mentores, coaches, consultores',
    categories: ['Aulas', 'Mentoria', 'Consultoria', 'Cursos', 'Workshops'],
    color: 'purple',
    defaultPalette: 'roxo-elegante',
    coverImages: coverImages.educacao
  },
  {
    id: 'personalizado',
    name: 'Personalizado',
    icon: 'Settings',
    description: 'Configure do seu jeito',
    categories: [],
    color: 'slate',
    defaultPalette: 'cinza-minimalista',
    coverImages: coverImages.personalizado
  }
];

export const demoPortfolio = {
  slug: 'joao-reformas',
  name: 'João Silva',
  business: 'João Reformas',
  tagline: 'Transformando sonhos em realidade há 15 anos',
  bio: 'Especialista em reformas residenciais e comerciais. Trabalho com qualidade e pontualidade, sempre buscando superar as expectativas dos meus clientes.',
  photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face',
  coverPhoto: coverImages.construcao[0],
  template: 'construcao',
  colorPalette: 'laranja-pro',
  phone: '24999998888',
  email: 'joao@reformas.com',
  instagram: '@joaoreformas',
  city: 'Volta Redonda, RJ',
  yearsExperience: 15,
  completedProjects: 200,
  categories: ['Reforma completa', 'Pintura', 'Elétrica', 'Hidráulica'],
  
  works: [
    {
      id: 1,
      title: 'Reforma Apartamento 80m²',
      description: 'Reforma completa incluindo cozinha americana, banheiros e pintura geral.',
      category: 'Reforma completa',
      images: [
        { url: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?w=600', type: 'after', caption: 'Cozinha finalizada' },
        { url: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=600', type: 'after', caption: 'Sala de estar' }
      ],
      date: '2024-12'
    },
    {
      id: 2,
      title: 'Pintura Residencial',
      description: 'Pintura interna e externa com preparação completa das paredes.',
      category: 'Pintura',
      images: [
        { url: 'https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?w=600', type: 'after', caption: 'Resultado final' }
      ],
      date: '2024-11'
    },
    {
      id: 3,
      title: 'Instalação Elétrica Completa',
      description: 'Troca de toda fiação e quadro de distribuição em casa de 120m².',
      category: 'Elétrica',
      images: [
        { url: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=600', type: 'after', caption: 'Quadro novo instalado' }
      ],
      date: '2024-10'
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: 'Maria Santos',
      photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face',
      text: 'Excelente profissional! Fez a reforma do meu apartamento com muito cuidado e no prazo combinado. Super recomendo!',
      rating: 5,
      service: 'Reforma completa',
      date: '2024-12'
    },
    {
      id: 2,
      name: 'Carlos Oliveira',
      photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
      text: 'João é muito profissional e honesto. A pintura ficou impecável e ele deixou tudo limpo após o serviço.',
      rating: 5,
      service: 'Pintura',
      date: '2024-11'
    },
    {
      id: 3,
      name: 'Ana Costa',
      photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face',
      text: 'Contratei para trocar a parte elétrica da casa e foi tudo perfeito. Preço justo e trabalho de qualidade.',
      rating: 5,
      service: 'Elétrica',
      date: '2024-10'
    }
  ],
  
  settings: {
    showWhatsApp: true,
    showEmail: true,
    showInstagram: true,
    acceptTestimonials: true,
    showPricing: false
  }
};

// Helpers
export const generatePortfolioSlug = (name) => {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
};

export const getTemplateIcon = (templateId) => {
  const template = portfolioTemplates.find(t => t.id === templateId);
  return template?.icon || 'Briefcase';
};

export const getTemplateColor = (templateId) => {
  const template = portfolioTemplates.find(t => t.id === templateId);
  return template?.color || 'slate';
};

export const getPalette = (paletteId) => {
  return colorPalettes.find(p => p.id === paletteId) || colorPalettes[0];
};

export const getTemplateCoverImages = (templateId) => {
  const template = portfolioTemplates.find(t => t.id === templateId);
  return template?.coverImages || coverImages.personalizado;
};

export const getDefaultPalette = (templateId) => {
  const template = portfolioTemplates.find(t => t.id === templateId);
  return template?.defaultPalette || 'cinza-minimalista';
};
